exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n._fc_struct .CodeMirror {\r\n  height: 450px;\n}\n._fc_struct .CodeMirror-line {\r\n  line-height: 16px !important;\r\n  font-size: 13px !important;\n}\n.CodeMirror-lint-tooltip {\r\n  z-index: 2021 !important;\n}\n._fc_struct .el-dialog__body {\r\n  padding: 0px 20px;\n}\r\n", ""]);

// exports
